/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { ManagedDevice, ManagedDevice$inboundSchema } from "./manageddevice.js";

export type ListManagedDevicesResult = {
  /**
   * Devices, newest first.
   */
  devices: Array<ManagedDevice>;
  /**
   * Cursor for the next page. Omitted on the last page.
   */
  nextCursor?: string | undefined;
};

/** @internal */
export const ListManagedDevicesResult$inboundSchema: z.ZodMiniType<
  ListManagedDevicesResult,
  unknown
> = z.pipe(
  z.object({
    devices: z.array(ManagedDevice$inboundSchema),
    next_cursor: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      "next_cursor": "nextCursor",
    });
  }),
);

export function listManagedDevicesResultFromJSON(
  jsonString: string,
): SafeParseResult<ListManagedDevicesResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListManagedDevicesResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListManagedDevicesResult' from JSON`,
  );
}
